import { SelectField } from './SelectField'
import { withSelectField } from './withSelectField'

const ConnectedSelectField = withSelectField(SelectField)

export { ConnectedSelectField as SelectField }
